import React, {Component} from 'react'
import ProfileBase from './helpers/ProfileBase'
import TestAnswersBox from './helpers/TestAnswersBox'
import TopExperienceBox from './helpers/TopExperienceBox'
import AdditionalTalentNotesBox from './helpers/AdditionalTalentNotesBox'

class TranslatorProfile extends Component {
  render() {
    return (
      <ProfileBase profileUrlPart="translator" render={( profileData ) => (
        <div>
          {profileData.ProfileType === 'Translator' &&
            <div>
              <div className="row">
                <div className="col-md-6 widget">
                  <div className="title">Experience</div>
                  <div className="row">
                    <div className="col">
                      <div className="row">
                        <div className="col-4">Number of translations:</div>
                        <div className="col-8">{profileData.NumberOfTranslations}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Productions:</div>
                        <div className="col-8">{profileData.ExperienceProductions}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Genres:</div>
                        <div className="col-8">{profileData.ExperienceGenres}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Additional experience:</div>
                        <div className="col-8">{profileData.Experience}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Studios:</div>
                        <div className="col-8">{profileData.LocalizationCompanies}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Clients:</div>
                        <div className="col-8">{profileData.ProductionContentOwners}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 widget">
                  <div className="title">Education</div>
                  <div className="row">
                    <div className="col">
                      <div className="row">
                        <div className="col-4">Native language:</div>
                        <div className="col-8">{profileData.NativeLanguage}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Additional languages:</div>
                        <div className="col-8">
                          {profileData.AdditionalLanguages.map((language, i) => (
                            <div key={i}>{language}</div>
                          ))}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-4">University degree:</div>
                        <div className="col-8">{profileData.UniversityDegree}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <AdditionalTalentNotesBox additionalNotes={profileData.AdditionalNotes} />
                <TopExperienceBox experiences={profileData.ExternalExperiences} />
              </div>
              <div className="row">
                <TestAnswersBox />
              </div>
            </div>
          }
        </div>
      )}/>
    )
  }
}

export default TranslatorProfile
